import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './tabContent.less';

class TabContent extends Component {
    constructor(props) {
        super(props);
		this.state = {nullRenderedContent: []};

		this.showOverlay = this.showOverlay.bind(this);
		this.closeOverlay = this.closeOverlay.bind(this);
	}
	componentWillMount() {
		if (!this.props.children || this.props.children.length === 0) {
			this.props.onNullRender();
		}
		else if (this.props.onRenderWithContent) {
			this.props.onRenderWithContent();
		}
		
	}
	componentDidUpdate(prevProps, prevState) {
		if (this.state.showOverlay && !prevState.showOverlay) {
			this.overlay.scrollIntoView();
		}
	}

    addTabToNullList(index) {
        return (previousState, currentProps) => {
            if(!previousState.nullRenderedContent.includes(index)) {
                return {...previousState, nullRenderedContent: previousState.nullRenderedContent.concat(index)};
            }
            else {
                return previousState;
            }
        };
    }
    trackNullContent(index) {
        this.setState(this.addTabToNullList(index), () => {
            if(this.state.nullRenderedContent.length >= React.Children.count(this.props.children)) {
                this.props.onNullRender();
            }
        });
	}
	showOverlay() {
		this.setState({
			showOverlay: true
		});
	}
	closeOverlay() {
		this.setState({
			showOverlay: false
		});
	}
    renderChildren(overlayId) {
        return React.Children.map(this.props.children,(child, i) => {
			return React.cloneElement(child,
				{
					onNullRender: () => this.trackNullContent(i),
					showOverlay: this.showOverlay,
					closeOverlay: this.closeOverlay,
					overlayId
				}
			);
        });
    }
    render() {
		const childCount = React.Children.count(this.props.children);

		const overlayId = `tab-overlay-${this.props.name}`
		const overlayDisplay = this.state.showOverlay ? 'block' : 'none';

        if(this.state.nullRenderedContent.length < childCount) {
			return (
				<div className={classNames('tab-content', this.props.className)} style={this.props.style}>
					{this.renderChildren(overlayId)}
					<div id={overlayId} className="tab-overlay" ref={overlay => this.overlay = overlay} style={{ display: overlayDisplay }} />
				</div>
			);
        }
        else {
            return null;
        }
    }
}
/**
 * name is a required type so that the tab group component can generate the tab label for this content.
 */
TabContent.propTypes = {
	children: PropTypes.node,
    name: PropTypes.string.isRequired,
    onNullRender: PropTypes.func
}

export default TabContent;



// WEBPACK FOOTER //
// ./src/react/containers/TabContent.jsx